// extracted by mini-css-extract-plugin
export default {"fashion":"index_fashion_ZI--t"};